module.exports = __webpack_public_path__ + "fonts/Marianne-Medium.a3a0a48.woff";